import React, { Component } from 'react';
import phoneImg from '../../static/images/login/phone.png'
import phoneCode from '../../static/images/login/code.png'
import loginClose from '../../static/images/login/close.png'
import AXIOS from "../../api/axios";
import { COURSE_URL } from "../../constants";
import './style.less';


export default class WebViewHeader extends Component {
  constructor (props) {
      super(props);
      this.state = {
         codeText: '请输入验证码',
         channelId: '',
         phoneInput: '',
         codeInput: '',
         count: 60,
         timeLiked: true
      }
  }

  
  // 获取手机号value
  phoneInputChange(){
    let value = this.refs.phoneInput.value
    this.setState({
      phoneInput: value
    })
  }
  // 获取验证码value
  codeInputChange(){
    // const { timeLiked } = this.state
    
    let value = this.refs.codeInput.value
    this.setState({
      codeInput: value
    })

  }
  // 关闭按钮
  closeHide = () => {
    this.props.parent.getChildrenClose(this, 'false')
  }
  // 跳转到服务协议页面
  toAgree(){
    // const { history } = this.props;
    // history.replace('/agreement')
    // this.props.history.push('/agreement')
    
    // history.push({
    //   pathname: `${COURSE_URL}/agreement}`,
    // });
    window.location.href = `${COURSE_URL}/agreement` 
  }
  
  // 登录
  toLogin = (channelId) =>{
    const { phoneInput, codeInput } = this.state
    let reg = /^[1][3,4,5,7,8][0-9]{9}$/
    let reg2 = /^[0-9]{6}$/
    let reg001 = /^[0][0][1][0-9]{8}$/
    let phoneTest = reg.test(phoneInput) || reg001.test(phoneInput)
    let codeTest  = reg2.test(codeInput)
    console.log('1212',reg.test(phoneInput), reg001.test(phoneInput),reg2.test(codeInput))
    console.log('233',phoneTest, codeTest)
    if(!phoneTest) {
      console.log('手机号正确')
      alert('请填写正确手机号')
      return
    }
    if(!codeTest) {
      console.log('验证码正确')
      alert('请填写正确验证码')
      return
    }
    AXIOS.login({data: { phone: phoneInput, smsCode: codeInput, channel: 'WX_MP', channelId: channelId } },
      (res, err) => {
        if (err) alert(err.errorMessage)
        else {
          console.log('登录成功',res)
          let params = {
            loginShow: false,
            id: res.id
          }
          this.props.parent.getChildrenMsg(this, params)
        }
      }
    )
  }

  // 验证码
  getCode = () => {
    const { timeLiked, phoneInput  } = this.state
    if(phoneInput === '') {
      alert('请输入手机号')
      return
    }
    if(!timeLiked) return
    AXIOS.smsCode({data: {phone: phoneInput, type: 1}},
      (res, err) => {
        if(err)  alert(err.errorMessage)
        else {
          alert('验证码已发送')
        }
      }
    )
    this.countDown()
      
  }
  countDown = () => {
     const { count } = this.state
     if(count === 1) {
       this.setState({
         count: 60,
         timeLiked: true
       })
     } else {
       this.setState({
         count: count - 1,
         timeLiked: false,
         codeText: count + 's'
       })
       setTimeout(this.countDown.bind(this), 1000)
     }
  }
  

  render(){
      const { loginModalShow, channelId } = this.props
      return(
          <div>
            { loginModalShow === true && 
            <div className="loginModal">
              <div className="loginContent">
                  <img className="close" src={loginClose} alt="close" onClick={ this.closeHide } />
                  <h1>用户登录</h1>
                  <div className="input-1">
                    <img src={phoneImg} alt="phone" />
                    <input type="text" placeholder="请输入手机号" ref="phoneInput" onChange = { ()=> this.phoneInputChange() } />
                  </div>
                  <div className="input-2">
                    <img src={phoneCode} alt="code" />
                    <input type="text" placeholder="请输入验证码" ref="codeInput" onChange = { ()=> this.codeInputChange() }  />
                    <span onClick={ this.getCode.bind(this) }>{ this.state.codeText }</span>
                  </div>
                  <div className="btn" onClick={ this.toLogin.bind(this, channelId) }>
                      登录
                  </div>
                  <p className="agreement">
                    未注册用户登录后自动注册<br />注册即表明同意
                    <span onClick={ this.toAgree }>《AirCourse服务协议》</span>
                  </p>
              </div>
            </div> 
          }
          </div>
      )
  }
}


// WEBPACK FOOTER //
// ./src/components/loginModal/login.jsx